import { GridColumnStyles } from '@common/common';
import {
  editColumn,
  getRowStyle,
} from '@grid/orders-grid/orders-grid.component';
import {
  createColDef,
  customerColumn,
  orderNrColumnForAdmin,
  partnerColumn,
} from '../order-columns';

const statusProvColumn = createColDef('prov_order_state')
  .h('Status (Backoffice)')
  .min(120)
  .max(160)
  .csc().data;

const statusColumn = createColDef('status_name')
  .h('Status (Montage)')
  .min(120)
  .max(160)
  .csc().data;

const orderDate = createColDef('prov_order_date')
  .h('Datum (Rechnung)')
  .min(100)
  .max(120).data;

const orderDateWork = createColDef('work_day')
  .h('Datum (Leistung)')
  .min(100)
  .max(120).data;

const licensePlateColumn = createColDef('plate')
  .h('Kennzeichen')
  .min(100)
  .max(150).data;

const kindColumn = createColDef('kind').h('Fahrzeugart').min(80).max(120).data;

export const orderNrBackofficeColumn = createColDef('prov_order_id')
  .h('ID (Backoffice)')
  .cic()
  .w(140).data;

export const orderGridOptionTypes: any = {
  billed: {
    headerHeight: 40,
    defaultColDef: {
      headerClass: 'def-col',
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellClass: GridColumnStyles.CELL_CLASS_STRING,
    },
    columnDefs: [
      orderNrColumnForAdmin,
      orderNrBackofficeColumn,
      statusProvColumn,
      statusColumn,
      orderDate,
      orderDateWork,
      customerColumn,
      licensePlateColumn,
      partnerColumn,
      kindColumn,
      editColumn,
    ],
    enableCellTextSelection: true,
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    getRowStyle,
  },
};
